<template>
    <div class="w-1200" style="position:relative;">
         <div class="r-tip">
                    <p class="pointer" :class="currentColumn=='招采中心'?'clickp':''" @click="changeColumn('招采中心')">招采中心</p>
                    <p class="pointer" :class="currentColumn=='招标中标'?'clickp':''" @click="changeColumn('招标中标')">招标中标</p>
                    <!-- <p class="pointer" :class="currentColumn=='器械招商'?'clickp':''" @click="changeColumn('器械招商')">器械招商</p> -->
                    <p class="pointer" :class="currentColumn=='采购信息'?'clickp':''" @click="changeColumn('采购信息')">采购信息</p>
                </div>
        <div v-if="currentColumn == '招采中心'&&columnType==1" class="procurement-center">
            <div class="w-950 p-1">
               
                <div class="title-more">
                    <div class="t-m-blue"></div>
                    <p class="t-m-t" style="width:150px;">最新采购信息</p>
                </div>
                <div class="box-bottom">
                    <div class="r-r-1-img">
                        <el-carousel indicator-position="none" height="300px">
                            <el-carousel-item v-for="(item,index) in imgs" :key="index" @click.native="getCGDetail('采购',item.procure)">
                                <el-image style="width: 100%; height: 100%;" :src="item.path" fit="contain" >
                                    <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                    <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                    </div> -->
                                </el-image>
                                <p class="img-title">{{item.title}}</p>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="r-r-1-items">
                        <div class="i-box"> 
                        <div class="item" v-for="(item,index) in procureList" :key="index" @click="getCGDetail('采购',item)">
                            <p class="i-title pointer p-lv">{{item.titleName}}</p>
                            <p class="i-time">{{item.createDate}}</p>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <!-- <div class="w-950 p-2 m-t-10">
                <div class="title-more">
                        <div class="t-m-blue"></div>
                        <p class="t-m-t" style="width:200px;">最新器械招商信息</p>
                        <p class="t-m-r-p pull-right" @click="changeColumn('器械招商')">查看所有</p>
                        <div class="pull-right" >
                            <p class="t-m-r-p pull-left" v-for="(item,index) in typeTop" :key="index" :class="{'t-m-r-b':typeCode==item.code}" @click="setTypeCode(item.code)"> {{item.name}}</p>
                        </div>
                </div>
                <div class="box-bottom">
                    <div class="item pointer" v-for="(item,index) in deviceList" :key="index" @click="getQXdetail(item.id)">
                        <div class="img"> -->
                            <!-- <img src="../../assets/image/home/home-img10.png"> -->
                            <!-- <el-image style="width: 100%; height: 100%" :src="item.images" fit="contain"> -->
                                <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                                <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                                </div> -->
                            <!-- </el-image>
                        </div>
                        <div class="content">
                            <p class="p1 p-lv">{{item.titleName}}</p>
                            <p class="p2 p-lv2">{{item.abstract}}</p>
                            <p class="p3"><span>{{item.lxrOrgCode}}</span> <span> {{item.createDate}}</span></p><el-button type="primary" style="background:linear-gradient(-90deg,rgba(242,174,56,1),rgba(255,149,0,1));border:0;float:right;" size="mini" icon="el-icon-edit-outline">留言资讯</el-button>
                        </div>
                    </div>
                </div> -->
            <!-- </div> -->
            <div class="w-950 p-3 m-t-10">
                <div class="title-triangle">
                    <p class="t-t-t pointer" :class="{active:BIDtype=='BID'}" @click="changeBID('BID')">招标信息<i class="el-icon-caret-bottom"></i></p>
                    <p class="t-t-t pointer" :class="{active:BIDtype=='WINBID'}" @click="changeBID('WINBID')">中标信息<i class="el-icon-caret-bottom"></i></p>
                    <!-- <div class="triangle"></div> -->
                </div>
                <div class="box-bottom">
                    <div class="item pointer" v-for="(item,index) in bidList" :key="index" @click="getCGDetail('招标',item)">
                        <div class="img">
                            <img src="../../assets/image/home/bid.png">
                        </div>
                        <div class="content">
                            <p class="p1">{{item.titleName}}</p>
                            <p class="p2"><span style="padding-right:10px;color:#434343;">发布时间</span><span style="padding-right:40px;">{{item.createDate}}</span> <span style="padding-right:10px;color:#434343;">采购单位</span> <span>{{item.publishOrgCode}}</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentColumn == '招标中标'&&columnType==1" class="tender-bid ">
            <div class="w-950 t-d-1">
                <div class="title-triangle">
                   <p class="t-t-t pointer" :class="{active:zcType=='BID'}" @click="changeBIDCenter('BID')">招标信息<i class="el-icon-caret-bottom"></i></p>
                    <p class="t-t-t pointer" :class="{active:zcType=='WINBID'}" @click="changeBIDCenter('WINBID')">中标信息<i class="el-icon-caret-bottom"></i></p>
                </div>
                <div class="t-d-1-b">
                    <com-list breadTitle="招标" returnType='item' :list="zcList" @getDetail="getCGDetail"></com-list>
                </div>
                <z-page :pageObj="page" @changePage1="changePage1"></z-page>
            </div>
        </div>
        <div v-if="currentColumn == '器械招商'&&columnType==1" class="equipment-investment ">
            <div class="w-950 e-i-1">
                <div class="left">
                    <div class="item" style="height:100%;">
                        <p class="p1">按标准目录</p>
                        <p v-for="(item,index) in typeAll" :key="index" class="p2 pointer " :class="{active:item.code==deviceTypeCode}" @click="getQXZSByCode(item.code)">{{item.name}}</p>
                    </div>
                </div>
                <div class="right">
                    <el-carousel indicator-position="none" height="500px" >
                            <el-carousel-item v-for="(item,index) in qxImgs" :key="index" @click.native="getQXdetail(item.id)">
                                 <el-image style="width: 100%; height: 100%;" :src="item.path" fit="contain" >
                                    <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                    <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                    </div> -->
                                </el-image>
                                 <p class="img-title">{{item.title}}</p>
                            </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div class="w-950 e-i-2 m-t-10">
                <div class="title-more">
                    <div class="t-m-blue"></div>
                    <p class="t-m-t" style="width:200px;">器械招经销商</p>
                </div>
                <div class="box-bottom">
                <div class="item pointer" v-for="(item,index) in qxList" :key="index" @click="getQXdetail(item.id)">
                    <el-row class="w-100 h-100" :gutter="20">
                        <el-col class="h-100" :span="5">
                            <!-- <el-image style="width: 100%; height: 100%" :src="topImportantNotice.fgpic" fit="contain"></el-image> -->
                            <el-image style="width: 100%; height: 100%" :src="item.images" fit="contain">
                                <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                                                <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                                                </div> -->
                            </el-image>
                            <!-- <img src="../../assets/image/home/home-img12.png"> -->
                        </el-col>
                         <el-col class="h-100" :span="14">
                            <p class="p1">{{item.titleName}}</p>
                            <p class="p2 p-lv-3">{{item.abstract}}</p>
                            <p class="p3"><span>刷新时间</span> {{item.createDate}}</p>
                            <!-- <p class="p3"><span style="color:#444444;padding-right:15px;">招商区域</span> 全国</p> -->
                        </el-col>
                         <el-col class="h-100" :span="5">
                            <p class="p1 p-lv-2">{{item.lxrOrgCode_text}}</p>
                            <p class="p3">联系人：{{item.lxrName}}</p>
                            <p class="p3">联系电话：{{item.lxrPhone}}</p>
                            <!-- <p class="p3">手机号码：13923365847</p> -->
                            <el-button type="primary" style="background:linear-gradient(-90deg,rgba(242,174,56,1),rgba(255,149,0,1));border:0;" size="mini" icon="el-icon-edit-outline">留言资讯</el-button>
                        </el-col>
                    </el-row>
                </div>
                <z-page :pageObj="page" @changePage1="changePage2"></z-page>
            </div>
            </div>
        </div>
        <div v-if="currentColumn == '采购信息'&&columnType==1" class="purchasing-information">
            <div class="w-950 p-i-1">
                <div class="title-more">
                    <div class="t-m-blue"></div>
                    <p class="t-m-t" style="width:200px;">最新采购信息</p>
                    <div style="width:300px;float:right;height:100%;padding-top:7px;">
                        <el-input style="width:200px;" size="small" v-model="cgWord" placeholder="请输入搜索关键词"></el-input><el-button type="primary" size="small" @click="pageZczxPage">搜索</el-button>
                    </div>
                </div>
                <div class="p-i-b">
                    <com-list breadTitle="采购" returnType='item' :list="zcList" @getDetail="getCGDetail"></com-list>
                </div>

               
                
                <z-page :pageObj="page" @changePage1="changePage1"></z-page>
            </div>
        </div>
        <div v-if="currentColumn == '器械招商'&&columnType==2" class="w-950 procurement-detail">
            <div class="p-d-1">
                <div class="title-more">
                    <div class="t-m-blue"></div>
                    <p class="t-m-t">器械招商</p>
                </div>
                <div class="p-d-b">
                    <p class="p1">{{qxDetail.titleName}}</p>
                    <div class="img pull-left">
                        <el-image style="width: 100%; height: 100%" :src="qxDetail.images" fit="contain">
                            <!-- <div slot="error"   class="image-slot" style="width:100%;height:100%;">
                            <img style="object-fit: fill;width:100%;height:100%;"  src="../../assets/image/home/home-img3.png">
                            </div> -->
                        </el-image>
                    </div>
                    <div class="right">
                        
                        <div class="item i-color">
                            <p class="p-l pull-left">品牌</p>
                            <p class="p-r pull-right">{{qxDetail.brand}}</p>
                        </div>
                        <div class="item">
                            <p class="p-l pull-left">型号</p>
                            <p class="p-r pull-right">{{qxDetail.xh}}</p>
                        </div>
                        <div class="item i-color">
                            <p class="p-l pull-left">产地</p>
                            <p class="p-r pull-right">{{qxDetail.address}}</p>
                        </div>
                        <div class="item">
                            <p class="p-l pull-left">产品注册号</p>
                            <p class="p-r pull-right">{{qxDetail.registNum}}</p>
                        </div>
                        <div class="item i-color">
                            <p class="p-l pull-left">用途</p>
                            <p class="p-r pull-right">{{qxDetail.purpose}}</p>
                        </div>
                        <div class="item">
                            <p class="p-l pull-left">招商状态</p>
                            <p class="p-r pull-right">{{qxDetail.zsStatus_text}}</p>
                        </div>
                        <div class="item i-color">
                            <p class="p-l pull-left">招商区域</p>
                            <p class="p-r pull-right">{{qxDetail.zsProvince_text}}{{qxDetail.zsCitie_text}}</p>
                        </div>
                        <!-- <div class="item">
                            <p class="p-l pull-left">浏览量</p>
                            <p class="p-r pull-right">12561</p>
                        </div> -->
                        <!-- <el-button type="primary" style="background:linear-gradient(-90deg,rgba(242,174,56,1),rgba(255,149,0,1));border:0;margin-left:20px;margin-top:20px;" icon="el-icon-edit-outline" @click="dialogVisible=true">我要招商，留言</el-button> -->
                    </div>
                </div>
            </div>
            <div class="p-d-2">
                <div class="title-triangle" >
                        <p class="t-t-t t-t-click">产品描述</p>
                        <!-- <div class="triangle"></div> -->
                </div>
                <div class="box-bottom">
                    <com-richtext :richtext="qxDetail.content"></com-richtext>
                </div>
            </div>
            <div class="p-d-3">
                <com-leave-word v-if="chatId" :chatId="chatId" :source="source"></com-leave-word>
            </div>
             
        </div>
        <div v-if="columnType==3" class="w-950 zcb-detail">
             <div class="title-more">
                    <div class="t-m-blue"></div>
                    <p class="t-m-t">详情</p>
            </div>
             <div class="h-d-b">
                <div class="title">
                    <p class="p1">{{bidDetail.titleName}}</p>
                    <p class="p2"><span style="padding-right:10px;">发布时间</span>  {{bidDetail.createDate}}       <span style="padding-left:50px;padding-right:10px;">发布人</span>  {{bidDetail.publishPerson}}</p>
                </div>
                <div class="content">
                    <com-richtext :richtext="bidDetail.content"></com-richtext>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Procurement from './Procurement.js';
export default Procurement;
</script>
<style lang="scss" scoped>
@import './Procurement.scss';
</style>